import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class ExpensesBook extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);


		this.state = {
			start_date 	: "",
			end_date 	: "",
			type:"all",
			listado:[],
			columns:[
				{title:'Fecha - Hra Donación'},
				{title:'Donador', width:'100px'},
				{title:'No. Unidad'},
				{title:'Procedencia'},
				{title:'T. Donación'},
				{title:'Comp + Vol'},
				{title:'F. Caducidad'},
				{title:'HGB'},
				{title:'HTO'},
				{title:'Gpo & RH'},
				{title:'Paciente'},
				{title:'F.Egreso'},
				{title:'T. Egreso'},
				{title:'Motivo Baja'},
				{title:'Hospital'},
				{title:'Receptor'},
				{title:'Gpo & RH'},
				{title:'Servicio'},
				{title:'Cama'},
				{title:'N. Expediente'},
				{title:'Comp + Vol'},
				{title:'Médico'},
				{title:'Entregado a'},
				{title:'Observaciones'},
			],
			filename:"Libreta Egresos",
			type_name:"",
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}


	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			aoColumnDefs: [
			   { "sWidth": "35px", "aTargets": 0 },
			   /*{ "sWidth": "70px", "aTargets": [1,2,3,4,9] },
			   { "sWidth": "100px", "aTargets": [5,7] },
			   { "sWidth": "12em", "aTargets": [6,8] },
			   { "sWidth": "70px", "aTargets": [12,13] },
			   { "sWidth": "13em", "aTargets": [11,14,15,16] }*/
			],
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	/*{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas+'\t\t\t'+this.state.medical, margin:[10,0,0,10] });
					
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},*/
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: true,
			info:false,
			ordering:false
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		if(e.target.name === 'type'){
			this.setState({
				type_name: e.target.options[e.target.selectedIndex].text
			})
		}

	}

	searching(){
		var columns = [
			{title:'Fecha - Hra Donación', width:'125px'},
			{title:'Donador',width:'400px'},
			{title:'No. Unidad', width:'70px'},
			{title:'Procedencia',width:'200px'},
			{title:'T. Donación',width:'150px'},
			{title:'Comp + Vol',width:'80px'},
			{title:'F. Caducidad',width:'95px'},
			{title:'HGB', width:'30px'},
			{title:'HTO', width:'30px'},
			{title:'Gpo & RH', width:'70px'},
			{title:'Paciente',width:'200px'},
			{title:'F.Egreso'},
			{title:'T. Egreso',width:'80px'},
			{title:'Motivo Baja',width:'150px'},
			{title:'Hospital',width:'200px'},
			{title:'Receptor',width:'200px'},
			{title:'Gpo & RH',width:'70px'},
			{title:'Servicio',width:'80px'},
			{title:'Cama'},
			{title:'N. Expediente'},
			{title:'Comp + Vol',width:'80px'},
			{title:'Médico',width:'200px'},
			{title:'Quimico',width:'200px'},
			{title:'Entregado a',width:'200px'},
			{title:'Observaciones',width:'250px'},
		];

		if(this.state.type !== 'all' && this.state.type !== 'discards'){
			//columns.splice(14,1)
		}

		if(this.state.type === 'discards'){
			columns.splice(14, 6);
			columns.splice(15, 4);
		}
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					option:this.state.type,
					health_facilities_id:sessionStorage.getItem('health_facilities_id')
				};
				
				var fecha1 = moment(this.state.start_date);
				var fecha2 = moment(this.state.end_date);

				var dias = fecha2.diff(fecha1, 'days');

				if(dias <= 31){
					this.props.waiting.handleShow('Buscando...');
					fetch(Config.default.apiGateway.URL+'reports/expenses_book',{
						method: 'POST',
						body:JSON.stringify(obj),
						headers: new Headers({
							'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					}).then(res => {
						this.props.waiting.handleClose();
						if(res.ok){
							return res.json();
						}else{
							res.text().then((msg)=>{
								swal('Error', msg, 'error');
							});
						}
					}).then(response => {
						if(response !== undefined){
							response.test_serology.map((s, i)=>{
								columns.splice((10 + i), 0, {title:s.code, id:s.id})
							});

							var list = [];
							response.res.map((r, i)=>{

								var parts = '';
								r.unit_parts.map((part, i)=>{
									if(part !== null){
										parts += (i === 0 ? '(' : '') + part + (i === r.unit_parts.length - 1 ? ')' : ', ')	
									}
									return parts;
								});

								var obj = [
									moment(r.donation_date).format('DD/MM/YYYY'),
									(r.donor_name !== null ? r.donor_name : "")+' '+parts,
									r.unit_number,
									r.donation_center,
									r.donation_type
								]

								var comp_offer = '';
								var cad_comp_offer = '';
								if(r.division_units !== null){
									r.division_units.map((c, j)=>{
										comp_offer += c.volume+(j === r.division_units.length - 1 ? '' : ', ');

										cad_comp_offer += moment(c.caducidad).format('DD/MM/YYYY HH:mm')+
															(j === r.division_units.length - 1 ? '' : ', ')
									})
								}
									
								obj.push(comp_offer, cad_comp_offer);

								obj.push(
									r.hgb_donor,
									r.hto_donor,
									r.unit_group_rh
								)

								var results = 0;
								var baja = 0;
								var baja_comp = 0;
								columns.map((c, i)=>{
									if(c.id !== undefined){
										var index = -1;
										if(r.serology_results !== null){
											index = r.serology_results.findIndex(item => item.analitical_test_id === c.id);
										}

										if(index !== -1){
											obj.push(r.serology_results[index].value);
										}else{
											obj.push('');
										}
										results++;

											
									}

									if(c.title === 'Motivo Baja'){
										baja = i;
									}

									if(c.title === 'N. Expediente'){
										baja_comp = i + 1;
									}
								})
								obj.push(
									r.patient_offer,//patient donor
									moment(r.expense_date).format('DD/MM/YYYY HH:mm'),
									r.type,
									r.discard_reason,//motivo baja
									r.receptor_center,
									r.receptor_patient,
									r.patient_group_rh,//patient_g_rh
									r.patient_service,
									r.patient_ubication,//cama,
									r.patient_expedient, //Expediente'},
									r.expense_unit,
									r.required_by,
									r.user_send,
									r.mensajero,
									r.observations
								)
								if(this.state.type !== 'all' && this.state.type !== 'discards'){
									obj.splice(baja,1);
									
								}
								if(this.state.type === 'discards'){
									obj.splice(baja, 6);
									obj.splice(baja+2, 4);
								}
								list.push(obj);

							})

							if(this.state.type !== 'all' && this.state.type !== 'discards'){
								var index = columns.findIndex(obj => obj.title === 'Motivo Baja');

								columns.splice(index, 1);
								
							}

							setTimeout(()=>{
								this.props.waiting.handleShow('Cargando...');
								this.$el = $(this.el);
								this.$el.DataTable().destroy();
								this.$el.empty();
							}, 500);

							setTimeout(()=>{
								this.props.waiting.handleClose();
								this.setTable();
							}, 1000);

							this.setState({
								listado: list,
								columns: columns
							});
							
						}
					});
				}else{
					swal('Error', 'La diferencia entre las fechas es de '+dias+' dias, la diferencia maxima entre la fecha desde y la fecha hasta debe ser de 31 dias', 'error')
				}	
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
				
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Paciente ->
					{this.state.filename}
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								<div className="col-xs-12 form-group">
									<span className="span-min">Tipo</span>
									<select className="form-control" name="type" id="type" 
										value={this.state.type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="patient">PACIENTE</option>
										<option value="distribution">DISTRIBUCIÓN</option>
										<option value="hemored">HEMORED</option>
										<option value="discards">BAJA</option>
									</select>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>


								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={'expenses-discards'} id="table-to-xls"  ref={el => this.el = el}>
										</table>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (ExpensesBook);